export const style = {
  dialogTitle: {
    mt: '15px',
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleVariant: 'h6',
  closeIcon: {
    color: 'action.active',
  },
  boxContent: {
    minHeight: 150,
    width: 600,
  },
  circular: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
} as const;
